module.exports = __webpack_public_path__ + "assets/Fieber.a5c5c638.png";